import { checkTargetGroupsValidity } from "@/helpers"
const validationRules = component => {
    component.formErrors = []
    let query = component.$store.getters.getChannelsQuery
    let startDate = query.start_date

    let targetGroupErrors = checkTargetGroupsValidity(query.target_group, startDate)
    if (targetGroupErrors.length > 0) {
        for (let i = 0; i < targetGroupErrors.length; i++) {
            component.formErrors.push(targetGroupErrors[i])
        }
    }
}
export { validationRules }
